import { default as Artists } from './artists';

export default Artists;



// WEBPACK FOOTER //
// ./src/components/pages/admin-portal/artists/index.js